import React, { useCallback, useEffect, useRef, useState } from "react";

export default function ClocksAudioPlayer({ audioDelay, audioUrl, setCurrentAudioTime, startAudioTime, audioRef, setIsAudioAvailable, refreshCounter }) {
    const [urlWithDelay, setUrlWithDelay] = useState(audioUrl);
    const initialStartAudioTimeRef = useRef(startAudioTime);

    const handleTimeUpdate = useCallback(() => {
        if (audioRef.current) {
            const currentTime = audioRef.current.currentTime - audioDelay;
            setCurrentAudioTime(Math.max(currentTime, 0));
        }
    }, [audioDelay, audioRef, setCurrentAudioTime]);

    useEffect(() => {
        setIsAudioAvailable(false);
    }, [setIsAudioAvailable, audioUrl]);

    useEffect(() => {
        setUrlWithDelay(`${audioUrl}#t=${audioDelay + initialStartAudioTimeRef.current}`);
    }, [refreshCounter, audioUrl, audioDelay]);

    return (
        <audio
            onLoadedData={() => setIsAudioAvailable(true)}
            onTimeUpdate={handleTimeUpdate}
            src={urlWithDelay}
            ref={audioRef}
            type="audio/mpeg"
            download
            id="player"
            preload="auto"
        />
    );
}
